module.exports = __webpack_public_path__ + "img/imageOne.b48fcf68.png";